document.addEventListener("DOMContentLoaded", function() {

  function updateThumbsBySku(sku) {
    const thumbs = document.querySelectorAll(".product-media--thumb[data-variant-sku]");
    thumbs.forEach(thumb => {
      const variantSku = thumb.getAttribute("data-variant-sku") || "";
      if (variantSku.includes(sku)) {
        thumb.style.display = "";      // visibile
      } else {
        thumb.style.display = "none";  // nascosto
      }
    });
  }

  // Gestione click su label
  document.addEventListener("click", function(e) {
    const label = e.target.closest("label[data-sku]");
    if (!label) return;
    const sku = label.getAttribute("data-sku");
    if (!sku) return;
    updateThumbsBySku(sku);
  });

  // Stato iniziale (pagina caricata)
  const checkedInput = document.querySelector(".arca-swatch-label input[checked]");
  if (checkedInput) {
    const parentLabel = checkedInput.closest(".arca-swatch-label[data-sku]");
    if (parentLabel) {
      const initialSku = parentLabel.getAttribute("data-sku");
      if (initialSku) {
        updateThumbsBySku(initialSku);
      }
    }
  }
});